import { useAppSelector } from '@hooks/redux.hooks';
import { useContingencyBlinking } from '@hooks/useContingencyBlinking';
import { useSelectorWithMapId } from '@hooks/useSelectorWithMapId';
import { hasSensorRoleFromActiveProfile } from '@redux/authent/authent.selectors';
import { selectEngagementFeatures } from '@redux/situation/situation.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { Layer, Source } from 'react-map-gl/mapbox';

import { ActionEnum } from '@/types/commons/commons.types';
import { FeatureTypeEnum, LayerNameEnum, SourceNameEnum } from '@/types/map.types';
import { SensorFamilyEnum } from '@/types/sensor/sensor.types';

import { engagedCircleLayer, engagedTargetBlinkingLayer, engagedTargetLayer } from './engagement.layer';

function EngagementLayer() {
  const engagementFeatures = useSelectorWithMapId(selectEngagementFeatures);
  const neutralSensorActionCommand = { action: ActionEnum.ACCESS, sensorFamily: SensorFamilyEnum.NEUTRAL };
  const accessNeutral = useAppSelector((state) => hasSensorRoleFromActiveProfile(state, neutralSensorActionCommand));

  useContingencyBlinking({
    sourceName: SourceNameEnum.ENGAGEMENT,
    layerNames: [LayerNameEnum.ENGAGED_TARGET, LayerNameEnum.ENGAGED_TARGET_CONTINGENCY],
    featureTypes: FeatureTypeEnum.ENGAGED_TARGET_ICON,
  });

  if (!isFeatureCollection(engagementFeatures) || !accessNeutral) return null;

  return (
    <Source id={SourceNameEnum.ENGAGEMENT} type="geojson" data={engagementFeatures}>
      <Layer {...engagedTargetLayer} />
      <Layer {...engagedTargetBlinkingLayer} />
      <Layer {...engagedCircleLayer} />
    </Source>
  );
}

export default EngagementLayer;
